import { CalendarProvider } from '../../commonTypes';
import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export const isValidCalendarToken = calendarToken => {
  const ans = isValidBase(calendarToken) && validateProps(calendarToken, ['email', 'provider']);
  return ans;
};
export const isFullCalendarToken = calendarToken => {
  if (isValidCalendarToken(calendarToken) && calendarToken.provider === CalendarProvider.ICLOUD) {
    return validateProps(calendarToken, ['grantId', 'accessToken']);
  }
  return isValidCalendarToken(calendarToken) && validateProps(calendarToken, ['grantId', 'accessToken', 'refreshToken']);
};
//# sourceMappingURL=CalendarToken.js.map